export const ONLINE_STATIC_ORDER = {
    channel: "ONLINE",
    counter: 434,
    created: { seconds: 1766199396, nanoseconds: 0 },
    customerEmail: "robert@gmsil.co",
    customerName: "Robert",
    customerPhone: "4509996600",
    deliveryAddress: null,
    feeTotal: 7.24,
    fees: [
        {
            amount: 7.24,
            disableTax: true,
            id: "1766062801714",
            matchCondition: "any",
            name: "FEE",
            payments: "",
            services: ["pickup", "delivery"]
        }
    ],
    items: [
        {
            amount: 1,
            category: "Entrée chaud/Appetizers/前菜",
            description: "",
            id: "45XZHiABPBQa0vuLJHjB",
            name: "Poulet popcorn/Chicken popcorn/爆米花鸡",
            order: 0,
            price: 3.95,
            totalPrice: 3.95
        },
        {
            amount: 1,
            category: "Entrée chaud/Appetizers/前菜",
            description: "",
            id: "SFpPjuHwZM1qnLgm6z8g",
            name: "Calmar frits/ Fried calamari/ 炸鱿鱼圈",
            order: 0,
            price: 3.95,
            totalPrice: 3.95
        }
    ],
    lastUpdated: { seconds: 1766204603, nanoseconds: 0 },
    notes: null,
    onlineStatus: "COMPLETE",
    paymentMethod: "stripe-1766069530974",
    serviceType: "pickup",
    sessionId: "anon_DqwsYQxOu8xVdQUQCVEX_mj9jph11",
    status: 0,
    storeId: "DqwsYQxOu8xVdQUQCVEX",
    storeName: "SuShi & Hot Pot",
    subtotal: 44.7,
    taxTotal: 6.69,
    taxes: [
        { amount: 4.46, name: "TVQ", rate: 9.975 },
        { amount: 2.24, name: "TPS", rate: 5 }
    ],
    tipAmount: 6.71,
    tipPercent: 15,
    total: 65.33,
    websiteLocation: {
        address: "4400 LaSalle Verdun Quebec H4G 2A8",
        locationName: "Mall Champlain Unit 1055",
        phone: "+1 (450) 999-6688",
        latitude: 45.4705,
        longitude: -73.4368,
        lat: 45.4705,
        lng: -73.4368
    }
};

export const LOCAL_STATIC_ORDER = {
    orderChannel: "DELIVERY",
    orderNumber: "DL040",
    sessionId: "DL040",
    posOrderId: "ALAYD052",
    storeName: "store3",
    tableName: "DL040",
    created: { seconds: 1766732765, nanoseconds: 0 },
    lastUpdated: { seconds: 1766732761, nanoseconds: 0 },
    customerData: {
        firstName: "TOMMY",
        lastName: "Zhang",
        address: "3565 Rue de Verdun, Verdun, QC H4G 1K5, Canada",
        address2: "",
        city: "Verdun",
        country: "Canada",
        postCode: "H4G 1K5",
        state: "Quebec",
        phone: "5145556633",
        latLng: {
            lat: 45.4682495,
            lng: -73.5710737
        },
        latitude: "45.4682495",
        longitude: "-73.5710737"
    },
    pickupAddress: "101 Rue Peel, Montréal, QC H3C 0Y1, Canada",
    pickupLat: 45.4932062,
    pickupLng: -73.5568903,
    pickupPhone: "+1 (450) 999-6688",
    pickupLocationName: "Mall Champlain Unit 1055",
    items: [
        {
            id: "otw9rCDGs68HZCFFYjKt",
            name: "Tenderloin Pork Slice (6pcs) / 重庆老肉片.",
            amount: 1,
            price: 3.25,
            category: "Meats / 肉类"
        },
        {
            id: "qHuxMeKQ008yJyv4ESoN",
            name: "Ginger Beef / 牛丝",
            amount: 1,
            price: 3.25,
            category: "Appetizers / 前菜"
        }
    ],
    deliveryFee: 5,
    total: 27.75,
    totalWithTaxes: 31.91,
    tipAmount: 0,
    taxes: [
        { taxName: "TVQ", taxAmount: 2.77, taxValue: "9.975" },
        { taxName: "TPS", taxAmount: 1.39, taxValue: "5" }
    ],
    websiteLocation: {
        address: "4400 LaSalle Verdun Quebec H4G 2A8",
        phone: "+1 (450) 999-6688",
        locationName: "Mall Champlain Unit 1055",
        latitude: 45.4705,
        longitude: -73.4368,
        lat: 45.4705,
        lng: -73.4368
    }
};
